import { Button, Table } from '@mui/joy'
import React, { useState } from 'react'
import { post, Token, url } from '../../../Script/Session';
import { useNavigate } from 'react-router-dom';

function DateiViewerAktivity({ data, update }) {

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            console.log("Selected file:", file);
            adddatei(file);
            
        }
    };
    function adddatei(file) {
        if (!file) return;
        console.log("Uploading...");

        const formData = new FormData();
        const body = {
            token: Token.get(),
            targetid: data.id,
        };

        formData.append("json", JSON.stringify(body));
        formData.append("file", file);

        fetch(url + "/api/aktivitäten/file", {
            method: "POST",
            body: formData,
        })
            .then(res => res.text())
            .then(text => {
                console.log(text);
                if (text === "OK") {
                    update();
                }
            })
            .catch(console.error);
    }
    const navigate = useNavigate();
    function del(objectid){
        let body = {};
        body.token = Token.get();
        body.action = "deletedatei";
        body.targetid = data.id;
        body.fileid = objectid;
        let response = post(body, "/aktivitäten");
        if (response == "LOGOUT"){
            navigate("/");
        }
        update();
    }
    return (
        <>
            <Table>
                <thead>
                    <tr>
                        <th>Dateiname</th>
                        <th>Größe</th>
                        <th>Download</th>
                        {
                            data?.editperms && (
                                <th>Löschen</th>
                            )
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        data && data?.dateien.map((item) => {
                            return (
                                <tr key={item.objectid}>
                                    <td>{item.name}</td>
                                    <td>{item.size}KB</td>
                                    <td><Button onClick={() => window.open(
                                                                            `${url}/api/filedownload/${item.objectid}/${item.name}`,
                                                                            "_blank",
                                                                            "noopener,noreferrer"
                                                                        )}>Download</Button></td>
                                    {
                                        data?.editperms && (
                                            <td><Button onClick={() => del(item.objectid)} color='danger'>Löschen</Button></td>
                                        )
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </Table>
            <Button component="label" sx={{ mt: 4 }}>
                Datei Hochladen
                <input
                    type="file"
                    hidden
                    onChange={handleFileChange}
                />
            </Button>
        </>
    )
}

export default DateiViewerAktivity
